import React from 'react'
import HeaderRedirection from './Components/HeaderRedirection'
import Redirection from './Components/Redirection'

const NpoRedirection = () => {
  return (
    <>
      <HeaderRedirection />
      <Redirection />
    </>
  )
}

export default NpoRedirection